export default __webpack_public_path__ + "img/8926311bee44343110af52273e7c3715.svg";